import React, { useState } from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { Box, Button } from "@material-ui/core";

import ScoreMangementContainer from "@jumbo/Dashboards/scoreManagement/ScoreMangementContainer";
import AddScoreDialog from "@jumbo/Dashboards/scoreManagement/AddScoreDialog";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.scoreManagement"} />, isActive: true },
];

const ScoreManagement = () => {
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  return (
    <PageContainer
      heading={<IntlMessages id="pages.scoreManagement" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Box
            marginBottom={"10px"}
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <IntlMessages id="pages.scoreManagement.description" />
            <Button
              variant="contained"
              color="primary"
              onClick={()=>setAddDialogOpen(true)}
            >
              اضافه کردن امتیاز
            </Button>
          </Box>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <ScoreMangementContainer />
          </div>
        </Grid>
      </GridContainer>
      <AddScoreDialog
        open={addDialogOpen}
        handleClose={() => setAddDialogOpen(false)}
      />
    </PageContainer>
  );
};

export default ScoreManagement;
